var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-accessary-footer"},[_c('SmartLink',{attrs:{"route":{ name: 'prime' }}},[_c('UkaskoLogo')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }